import React from 'react';
import DeviceAwareImage from '../../../ExperienceBuilder/DeviceAwareImage';
export function assetKind(asset: {
    type?: string;
    name?: string;
    url: string;
}) {
    const type = asset.type ?? '',
        name = asset.name ?? asset.url.split('?')[0];
    if (type.startsWith('audio/') || /\.(m4a|mp3|wav)$/i.test(name))
        return 'audio';
    if (type.startsWith('video/') || /\.(mp4|mov|webm)$/i.test(name))
        return 'video';
    if (type.startsWith('image/') || /\.(png|jpe?g|gif|webp)$/i.test(name))
        return 'image';
    return 'file';
}
export default function AssetPreview({
    asset,
    compact = false,
}: {
    asset: { type?: string; name?: string; url: string };
    compact?: boolean;
}) {
    const kind = assetKind(asset);
    if (kind === 'audio')
        return (
            <audio
                aria-label={asset.name || 'Audio asset'}
                controls
                preload="none"
                className="max-w-full"
                src={asset.url}
                onClick={(e) => e.stopPropagation()}
            />
        );
    if (kind === 'video')
        return (
            <video
                aria-label={asset.name || 'Video asset'}
                controls
                preload="metadata"
                className="max-h-48 max-w-full"
                src={asset.url}
                onClick={(e) => e.stopPropagation()}
            />
        );
    if (kind === 'file')
        return (
            <span className="p-3 text-sm">
                {asset.name || 'Processing file'}
            </span>
        );
    return (
        <DeviceAwareImage
            src={asset.url}
            alt={asset.name || ''}
            maxWidth={compact ? 50 : 200}
            maxHeight={compact ? 50 : 200}
            showDimensions={!compact}
            isHovering={false}
        />
    );
}
